export default __webpack_public_path__ + "static/media/element_77.05f21f5c.webp";